// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom"; // navigation for status click
// import { Container, Row, Col } from "react-bootstrap";
// import { BiSupport } from "react-icons/bi";
// import { MdIncompleteCircle } from "react-icons/md";

// const API_URL = process.env.REACT_APP_API_URL;

// // Map string names to actual React Icon components
// const iconMap = {
//   BiSupport: BiSupport,
// };

// const CallingLeadReport = () => {
//   const [dashboardData, setDashboardData] = useState([]);
//   const [completeCount, setCompleteCount] = useState(0);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   // States for custom message modal
//   const [showMessageModal, setShowMessageModal] = useState(false);
//   const [messageModalContent, setMessageModalContent] = useState({
//     title: "",
//     text: "",
//     type: "",
//     confirmAction: null,
//   });

//   const showCustomMessageModal = (title, text, type, confirmAction = null) => {
//     setMessageModalContent({ title, text, type, confirmAction });
//     setShowMessageModal(true);
//   };

//   const closeCustomMessageModal = () => {
//     setShowMessageModal(false);
//     setMessageModalContent({ title: "", text: "", type: "", confirmAction: null });
//   };

//   const getAuthToken = () => {
//     return localStorage.getItem("token");
//   };

//   useEffect(() => {
//     const fetchDashboardData = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const token = getAuthToken();
//         if (!token) {
//           showCustomMessageModal("Authentication Error", "Authentication token not found. Please log in.", "error");
//           return;
//         }

//         const response = await fetch(`${API_URL}/calling-lead-report`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (!response.ok) {
//           if (response.status === 401) {
//             showCustomMessageModal("Authorization Error", "Unauthorized: Please log in again.", "error");
//           } else {
//             const errorData = await response.json();
//             showCustomMessageModal("Error", errorData.message || "Failed to fetch dashboard data.", "error");
//           }
//           throw new Error(response.statusText);
//         }

//         const rawData = await response.json();

//         const getCount = (status) => {
//           return rawData.data?.find((item) => item.status === status)?.count || 0;
//         };

//         const transformedData = [
//           { title: "Not Interested", value: getCount("Not Interested"), icon: "BiSupport" },
//           { title: "Already Purchased", value: getCount("Already Purchased"), icon: "BiSupport" },
//           { title: "Looking in Low Budget", value: getCount("Looking in Low Budget"), icon: "BiSupport" },
//           { title: "Looking in Different Location", value: getCount("Looking in Different Location"), icon: "BiSupport" },
//           { title: "In Follow Up Hot", value: getCount("In Follow Up Hot"), icon: "BiSupport" },
//           { title: "Looking in Commercial Use", value: getCount("Looking in Commercial Use"), icon: "BiSupport" },
//           { title: "Details sent visit not done", value: getCount("Details sent visit not done"), icon: "BiSupport" },
//           { title: "Call not Pickup", value: getCount("Call not Pickup"), icon: "BiSupport" },
//           { title: "In Follow Up", value: getCount("In Follow Up"), icon: "BiSupport" },
//           { title: "In Follow Up Booking Done", value: getCount("In Follow Up Booking Done"), icon: "BiSupport" },
//           { title: "Invalid Mobile Number", value: getCount("Invalid Mobile Number"), icon: "BiSupport" },
//           { title: "M Profile", value: getCount("M Profile"), icon: "BiSupport" },
//           { title: "In Follow Up Site Visit Done Booking Pending", value: getCount("In Follow Up Site Visit Done Booking Pending"), icon: "BiSupport" },
//           { title: "In Follow Up Booking Done Payment Pending", value: getCount("In Follow Up Booking Done Payment Pending"), icon: "BiSupport" },
//           { title: "New", value: getCount("New"), icon: "BiSupport" },
//         ];

//         setDashboardData(transformedData);
//         setCompleteCount(rawData.complete_count || 0);
//       } catch (err) {
//         console.error("Fetch dashboard data error:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDashboardData();
//   }, []);

//   if (loading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
//         <div className="spinner-border text-primary" role="status">
//           <span className="sr-only">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return null;
//   }

//   return (
//     <div className="padding_15">
//       <div className="dashboard">
//         <Row>
//           <Col xl={12}>
//             <div className="stats-card">
//               <div className="d-flex align-items-center gap-2 card-body text-center p-2">
//                 <div className="stats-icon">
//                   <MdIncompleteCircle className="fs-2 text-white"></MdIncompleteCircle>
//                 </div>
//                 <div className="d-flex align-items-center justify-content-between w-100">
//                   <h6 className="stats-label">Total Calling Leads</h6>
//                   <h2 className="stats-number">{completeCount}</h2>
//                 </div>
//               </div>
//               <div className="stats-decor"></div>
//             </div>
//           </Col>
//         </Row>
//         <hr />
//         <Row className="g-4">
//           {dashboardData.length > 0 ? (
//             dashboardData.map((item, index) => {
//               const IconComponent = iconMap[item.icon];
//               return (
//                 <div key={index} className="col-xs-12 col-sm-6 col-md-4 col-lg-4">
//                   <div
//                     className={`card bg_card_design clickable-card`}
//                     onClick={() => navigate(`/upload-property-lead-csv?status=${encodeURIComponent(item.title)}`)}
//                     style={{ cursor: "pointer" }}
//                   >
//                     <div className="card-body gap-2 d-flex align-items-center justify-content-start">
//                       {IconComponent && (
//                         <div className="icon_dashboard">
//                           <IconComponent size={50} className="text-white" />
//                         </div>
//                       )}
//                       <div>
//                         <div className="card-title text-dark">{item.title}</div>
//                         <div className="card-text">{item.value}</div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })
//           ) : (
//             <Col xs={12}>
//               <div className="text-center text-muted mt-5">No dashboard data available.</div>
//             </Col>
//           )}
//         </Row>
//       </div>
//     </div>
//   );
  
// };

// export default CallingLeadReport;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Modal, Button } from "react-bootstrap";
import { BiSupport } from "react-icons/bi";
import { MdIncompleteCircle } from "react-icons/md";

const API_URL = process.env.REACT_APP_API_URL;

// Map string names to actual React Icon components
const iconMap = {
  BiSupport: BiSupport,
};

const CallingLeadReport = () => {
  const [dashboardData, setDashboardData] = useState([]);
  const [completeCount, setCompleteCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // States for custom message modal
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageModalContent, setMessageModalContent] = useState({
    title: "",
    text: "",
    type: "",
    confirmAction: null,
  });

  const showCustomMessageModal = (title, text, type, confirmAction = null) => {
    setMessageModalContent({ title, text, type, confirmAction });
    setShowMessageModal(true);
  };

  const closeCustomMessageModal = () => {
    setShowMessageModal(false);
    setMessageModalContent({
      title: "",
      text: "",
      type: "",
      confirmAction: null,
    });
  };

  const getAuthToken = () => {
    return localStorage.getItem("token");
  };

  useEffect(() => {
    const fetchDashboardData = async () => {
      setLoading(true);
      setError(null);
      try {
        const token = getAuthToken();
        if (!token) {
          showCustomMessageModal(
            "Authentication Error",
            "Authentication token not found. Please log in.",
            "error",
          );
          return;
        }

        const response = await fetch(`${API_URL}/calling-lead-report`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          if (response.status === 401) {
            showCustomMessageModal(
              "Authorization Error",
              "Unauthorized: Please log in again.",
              "error",
            );
          } else {
            const errorData = await response.json();
            showCustomMessageModal(
              "Error",
              errorData.message || "Failed to fetch dashboard data.",
              "error",
            );
          }
          throw new Error(response.statusText);
        }

        const rawData = await response.json();

        const getCount = (status) => {
          return rawData.data?.find((item) => item.status === status)?.count || 0;
        };

        const transformedData = [
          { title: "Not Interested", value: getCount("Not Interested"), icon: "BiSupport" },
          { title: "Already Purchased", value: getCount("Already Purchased"), icon: "BiSupport" },
          { title: "Looking in Low Budget", value: getCount("Looking in Low Budget"), icon: "BiSupport" },
          { title: "Looking in Different Location", value: getCount("Looking in Different Location"), icon: "BiSupport" },
          { title: "In Follow Up Hot", value: getCount("In Follow Up Hot"), icon: "BiSupport" },
          { title: "Looking in Commercial Use", value: getCount("Looking in Commercial Use"), icon: "BiSupport" },
          { title: "Details sent visit not done", value: getCount("Details sent visit not done"), icon: "BiSupport" },
          { title: "Call not Pickup", value: getCount("Call not Pickup"), icon: "BiSupport" },
          { title: "In Follow Up", value: getCount("In Follow Up"), icon: "BiSupport" },
          { title: "In Follow Up Booking Done", value: getCount("In Follow Up Booking Done"), icon: "BiSupport" },
          { title: "Invalid Mobile Number", value: getCount("Invalid Mobile Number"), icon: "BiSupport" },
          { title: "M Profile", value: getCount("M Profile"), icon: "BiSupport" },
          { title: "In Follow Up Site Visit Done Booking Pending", value: getCount("In Follow Up Site Visit Done Booking Pending"), icon: "BiSupport" },
          { title: "In Follow Up Booking Done Payment Pending", value: getCount("In Follow Up Booking Done Payment Pending"), icon: "BiSupport" },
          { title: "New", value: getCount("New"), icon: "BiSupport" },
        ];

        setDashboardData(transformedData);
        setCompleteCount(rawData.complete_count || 0);
      } catch (err) {
        console.error("Fetch dashboard data error:", err);
        setError(err.message || "Failed to load dashboard.");
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ---------------- LOADING ----------------
  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
        }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  if (error && dashboardData.length === 0) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
          padding: "30px",
        }}
      >
        <div className="text-center text-muted">{error}</div>
      </div>
    );
  }

  // ---------------- MAIN ----------------
  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "30px 24px",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
        }}
      >
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          {/* 🎯 HEADER CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              padding: "20px 24px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "20px",
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                width: "52px",
                height: "52px",
                borderRadius: "14px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "24px",
                boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                flexShrink: 0,
              }}
            >
              📊
            </div>
            <div style={{ flex: 1, minWidth: "200px" }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "24px",
                  fontWeight: "800",
                  color: "#1e3a5f",
                  letterSpacing: "-0.5px",
                }}
              >
                Calling Lead Report
              </h1>
              <p
                style={{
                  margin: "2px 0 0",
                  fontSize: "13px",
                  color: "#64748b",
                  fontWeight: "500",
                }}
              >
                Overview of all calling leads by status
              </p>
            </div>
          </div>

          {/* 🎯 TOTAL CARD */}
          <div
            style={{
              background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.25)",
              padding: "24px 28px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "24px",
              color: "#ffffff",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "14px",
                background: "rgba(255, 255, 255, 0.18)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <MdIncompleteCircle className="fs-2 text-white" />
            </div>
            <div
              style={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: "10px",
              }}
            >
              <h6
                style={{
                  margin: 0,
                  fontSize: "15px",
                  fontWeight: "600",
                  letterSpacing: "0.3px",
                  color: "rgba(255,255,255,0.9)",
                }}
              >
                Total Calling Leads
              </h6>
              <h2
                style={{
                  margin: 0,
                  fontSize: "34px",
                  fontWeight: "800",
                  letterSpacing: "-0.5px",
                }}
              >
                {completeCount}
              </h2>
            </div>
          </div>

          {/* 🎯 STATUS CARDS */}
          <Row className="g-3">
            {dashboardData.length > 0 ? (
              dashboardData.map((item, index) => {
                const IconComponent = iconMap[item.icon];
                return (
                  <div
                    key={index}
                    className="col-xs-12 col-sm-6 col-md-4 col-lg-4"
                  >
                    <div
                      onClick={() =>
                        navigate(
                          `/upload-property-lead-csv?status=${encodeURIComponent(
                            item.title,
                          )}`,
                        )
                      }
                      style={{
                        background: "#ffffff",
                        border: "1.5px solid #e2e8f0",
                        borderRadius: "14px",
                        padding: "18px 20px",
                        display: "flex",
                        alignItems: "center",
                        gap: "14px",
                        cursor: "pointer",
                        transition: "all 0.25s ease",
                        boxShadow: "0 4px 12px rgba(30, 87, 153, 0.06)",
                        height: "100%",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-3px)";
                        e.currentTarget.style.boxShadow =
                          "0 12px 24px rgba(30, 87, 153, 0.15)";
                        e.currentTarget.style.borderColor = "#93c5fd";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 4px 12px rgba(30, 87, 153, 0.06)";
                        e.currentTarget.style.borderColor = "#e2e8f0";
                      }}
                    >
                      {IconComponent && (
                        <div
                          style={{
                            width: "48px",
                            height: "48px",
                            borderRadius: "12px",
                            background:
                              "linear-gradient(135deg, #1e5799, #2b6cb0)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#ffffff",
                            flexShrink: 0,
                            boxShadow: "0 6px 14px rgba(30, 87, 153, 0.25)",
                          }}
                        >
                          <IconComponent size={26} className="text-white" />
                        </div>
                      )}
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "#1e3a5f",
                            marginBottom: "4px",
                            lineHeight: 1.3,
                          }}
                        >
                          {item.title}
                        </div>
                        <div
                          style={{
                            fontSize: "22px",
                            fontWeight: "800",
                            color: "#1e5799",
                            letterSpacing: "-0.3px",
                          }}
                        >
                          {item.value}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <Col xs={12}>
                <div className="text-center text-muted mt-5">
                  No dashboard data available.
                </div>
              </Col>
            )}
          </Row>

          {/* Footer Copyright */}
          <p
            style={{
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "12.5px",
              marginTop: "24px",
              fontWeight: "500",
            }}
          >
            © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
            Rights Reserved.
          </p>
        </div>
      </div>

      {/* 🎯 MESSAGE MODAL */}
      <Modal show={showMessageModal} onHide={closeCustomMessageModal} centered>
        <Modal.Header
          closeButton
          className={`border-top border-4 ${
            messageModalContent.type === "success"
              ? "border-success"
              : messageModalContent.type === "error"
                ? "border-danger"
                : "border-warning"
          }`}
        >
          <Modal.Title
            className={`modal-title ${
              messageModalContent.type === "success"
                ? "text-success"
                : messageModalContent.type === "error"
                  ? "text-danger"
                  : "text-warning"
            }`}
          >
            {messageModalContent.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-secondary">
          <p>{messageModalContent.text}</p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          {messageModalContent.confirmAction ? (
            <>
              <Button variant="secondary" onClick={closeCustomMessageModal}>
                Cancel
              </Button>
              <Button
                variant={
                  messageModalContent.type === "warning" ? "warning" : "primary"
                }
                onClick={() => {
                  messageModalContent.confirmAction();
                  closeCustomMessageModal();
                }}
              >
                Confirm
              </Button>
            </>
          ) : (
            <Button
              variant={
                messageModalContent.type === "success"
                  ? "success"
                  : messageModalContent.type === "error"
                    ? "danger"
                    : "primary"
              }
              onClick={closeCustomMessageModal}
            >
              OK
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CallingLeadReport;
